import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import IconButton from "@material-ui/core/IconButton";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import { Link } from "react-router-dom";

const verySmall = 321;
//const iphone5 = 321;
const p20Pro = 365;
const iphone6plus = 414;

const useStyles = makeStyles(theme => ({
  root: {
    width: 200,
    fontSize: 20,
    margin: 10,
    textDecoration: "none",
    [theme.breakpoints.down(p20Pro)]: {
      width: "46%",
      margin: 4
    },
    [theme.breakpoints.up(p20Pro)]: {
      width: "46%",
      margin: 4
    },
    [theme.breakpoints.up(iphone6plus)]: {
      width: 190
    },
    [theme.breakpoints.down(verySmall)]: {
      width: "46%",
      margin: 4
    }
  },
  image: {
    width: 180,
    height: 180,
    margin: "0 auto",
    [theme.breakpoints.down(p20Pro)]: {
      width: 166,
      height: 166
    },
    [theme.breakpoints.up(p20Pro)]: {
      width: 164,
      height: 164
    },
    [theme.breakpoints.up(iphone6plus)]: {
      width: 190
    },
    [theme.breakpoints.down(verySmall)]: {
      width: 150,
      height: 150
    }
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%"
  },
  name: {
    color: "#3b5998",
    fontSize: 13,
    fontWeight: 500,
    height: 25,
    padding: 8,
    textDecoration: "none"
  },
  actions: {
    marginTop: 10,
    justifyContent: "center",
    padding: 0
  },
  price: {
    color: "#222",
    lineHeight: 2,
    fontSize: 14,
    fontWeight: 800,
    marginTop: 10
  },
  add: {
    color: "#3498db",
    fontSize: 16
  },
  media: {
    paddingTop: "56.25%", // 16:9
    height: 0
  },
  CardContent: {
    margin: "0 auto",
    textAlign: "center",
    padding: 0
  },
  AddIcon: {}
}));

const ItemCard = props => {
  let { item, cart } = props;

  const classes = useStyles();
  let domain = "products/";
  let imageLink = domain + item.code + ".png";
  let updatedAmountAvailable = 0;
  const [amountAvailable, setAmountAvailable] = useState(item.amountAvailable);
  let amountInCart = 0;

  const addToCart = item => {
    cart.items.map(product => {
      if ((product.name = item.name)) {
        amountInCart = amountInCart + 1;
      }
    });
    console.log(cart);

    if (amountAvailable - amountInCart > 0) {
      updatedAmountAvailable = amountAvailable - 1;
      setAmountAvailable(updatedAmountAvailable);
      props.add(item);
    } else {
      alert("Cant add more than available");
    }
  };

  return (
    <Card
      className={classes.root}
      elevation={0}
      component={Link}
      to={"../productDetails/" + item.id}
    >
      <CardMedia
        className={classes.image}
        image={imageLink}
        title={item.name}
      />

      <CardContent className={classes.CardContent}>
        <Typography
          variant="body2"
          color="textSecondary"
          component="p"
          className={classes.name}
        >
          {item.name}
        </Typography>
      </CardContent>

      <CardActions disableSpacing className={classes.actions}>
        <Typography
          variant="body2"
          color="textSecondary"
          component="p"
          className={classes.price}
        >
          R{item.price}
        </Typography>
      </CardActions>
    </Card>
  );
};

export default ItemCard;
